import {
  Analysis,
  DashboardConfigurationDependencies,
  Granularity,
} from '../../../../dashboard-config/dashboard-config.model';
import { DashboardFilter } from '../../../../filters/dashboard_filter';
import {
  DashboardSubMarketSingleSelectFilter,
  DashboardSubMarketsMultiSelectFilter,
  DashboardWzClassesMultiSelectFilter,
} from '../../../../filters/dashboard_filter_implementations';
import { ForecastStructureLegendMapKind } from './dashboard-forecast-structure.definition';

export const FORECAST_STRUCTURE_SHELL_ID = 'forecast-structure' as const;

export type DashboardForecastStructureShell =
  | 'branchenstruktur'
  | 'teilmarktstruktur';

export interface DashboardForecastStructureShellProfile {
  id: typeof FORECAST_STRUCTURE_SHELL_ID;
  analysisId: Analysis;
  granularityId: Granularity;
  sortingKey: string;
  legendMapKind: ForecastStructureLegendMapKind;
  buildGranularityFilters: (
    deps: DashboardConfigurationDependencies,
  ) => DashboardFilter<any>[];
}

export const dashboardForecastStructureShellProfiles: Record<DashboardForecastStructureShell, DashboardForecastStructureShellProfile> = {
  branchenstruktur: {
    id: FORECAST_STRUCTURE_SHELL_ID,
    analysisId: Analysis.Forecast,
    granularityId: Granularity.SubMarkets,
    sortingKey: 'sub_market_name',
    legendMapKind: 'submarket',
    buildGranularityFilters: (deps) => [
      new DashboardSubMarketsMultiSelectFilter(deps.localDatasetsService, {
        excludedValues: deps.sumSubMarketIds,
      }),
    ],
  },
  teilmarktstruktur: {
    id: FORECAST_STRUCTURE_SHELL_ID,
    analysisId: Analysis.Forecast,
    granularityId: Granularity.WzClasses,
    sortingKey: 'wz_name',
    legendMapKind: 'wz',
    buildGranularityFilters: (deps) => [
      new DashboardSubMarketSingleSelectFilter(deps.localDatasetsService, {
        excluded: deps.sumSubMarketIds,
      }),
      new DashboardWzClassesMultiSelectFilter(deps.localDatasetsService, {}),
    ],
  },
};
